module.exports = __webpack_public_path__ + "static/media/brg_logo.ed8027d5.svg";